/**
 * 所有使用的cmd应该统计到该类上
 * @author zhudc
 * @date 2020-05-29
 */
import { checkIsAndroid } from './SystemUtil';
import { getAppName } from './NativeUtil';
import {
  ANDROID_QLISTEN_APPKEY,
  IOS_QLISTEN_APPKEY,
  ANDROID_LANGEASY_APPKEY,
  IOS_LANGEASY_APPKEY,
  ANDROID_LEXIS_APPKEY,
  IOS_LEXIS_APPKEY,
} from '../config/AliConfig';

// 恢复购买 ios
export const RESTORE_PURCHASE = 'restore_purchase';

// Android GOIKOI 前端将商品id传给客户端，客户端返回用户当地价格数据。回调函数 window.action.get_local_price = (data)=>{}
export const GET_LOCAL_PRICE = 'get_local_price';

// 调用客户端cmd=webview_goback，客户端需要监听该事件有返回记录直接返回，没有返回记录关闭webview
export const GOBACK = 'webview_goback';

export const WEBVIEW_GOBACK = 'webview_goback';

// 该接口供js调用native的当前课文暂停播放功能，相当于点击了播放控制条中的暂停按钮。如果此时课文主音频尚未开始播放，则不做任何处理；如果此时处于播放状态，则暂停主音频的播放。
export const PLAYBACK_SUPPRESS = 'playback_suppress';

// 当用户点击富媒体播放时，webview告诉客户端已经播放
export const RICH_MEDIA_DID_PLAY = 'rich_media_did_play';

// 用户登录
export const USER_LOGIN = 'user_login';

// 打开外部浏览器
export const OPEN_URL = 'open_url';

// 透传统计
export const MOBCLICK = 'mobclick';

// 消息通知
export const ENABLED_notication = 'enabled&feat=notication';

export const LOCATION_ACCOUNT_CENTER = 'location_account_center';

export const LOCATION_FEEDBACK = 'location_feedback';

export const SAVE_IMAGE = 'save_image'; // 保存图片

export const SAVE_BASE64_IMAGE = 'save_base64_image'; // 保存base64图片

export const TAG_CHANGED = 'tag_changed'; // 偏好设置标签改变

export const ALI_PAY = 'alipay'; // 支付宝购买

export const IAP_PAY = 'iap'; // 支付宝购买

export const QUERY_IAP = 'query_iap'; // 判断是否iap支付

export const PAYCOIN = 'paycoin'; // 酷币支付、iap支付

export const COINPAYED = 'coinpayed'; // 酷币支付成功

export const CLOSE_VIEW = 'close_view'; // 关闭页面，Android不背单词貌似不支持这个事件了改用webview_goback，据测试目前Android不背是可以支持该事件的

export const CHECK_INSTALLED = 'checkInstalled'; // 检查是否安装微信 参数app=wechat | mayun | (alipay只有朗易思听支持)

export const POP_WORD = 'pop_word'; // 查词并且弹出

export const HIDE_POP_WORD = 'hide_pop_word'; // 查词并且弹出

export const ENABLE_POP_GESTURE = 'enable_pop_gesture'; // 开启iOS返回手势，使用js返回enable=0未禁止，1开启

export const SHARE = 'share'; //import android版本4.3位置 Android分享文字platform=wechattype=text&text=xxx而iOS分享文字是platform=wechattype=text&title=xxx，Android版qq不能分享纯文本

export const CALENDAR = 'calendar'; //日历提醒,废弃

export const CALENDARS = 'calendars'; //日历提醒 ex:`cmd=calendars&events=${encodeEvents}&id=${this.calendarsBody.event_id}`; 回调函数 window.action.calendars = (state)=>{}

export const ENABLE = 'enable'; // 设置权限`cmd=enable&feat=${type}` type:microphone photos notification 回调函数 window.action.set_permissions = (feat,state)=>{}//state:1 开通成功

export const QUERY_ENABLE = 'query_enabled'; // 查询权限`cmd=enable&feat=${type}` type:microphone photos notification window.action.query_permissions = (feat,state)=>{}//state:1 已成功

export const PERMISSIONS_PHOTOS = 'photos'; //photos权限  接受回调方法window.action.query_permissions = (feat,state)=>{}//state:1 已成功

export const ROTATE_SCREEN = 'rotate_screen'; //mode=portrait|landscape，旋转客户端屏幕，目前只有不背单词实现

export const QUERY_USER_NETTYPE = 'query_user_nettype'; // 查询网络类型

export const QUERY_USER_NETISP = 'query_user_netisp'; // 查询网络运营商

// cmd=clipboard&text=${encodeURIComponent('复制的内容');// 复制 仅安卓有该方法
// WebviewActionUtil.clipboardCallback(() => {});

/**
 * 执行cmd后阻塞
 * @param {String} str
 * @returns {Promise}
 */
export function executeCmdPromise(str: string) {
  executeCmd(str);
  return new Promise((resolve: any) => {
    setTimeout(() => {
      resolve();
    }, 100);
  });
}

/**
 * 以对象方式运行客户端命令，
 * @param {Object} obj
 */
function executeCmdByObj(obj: any) {
  // 只有iOS不背url中有多个参数会出现&符号需要encodeUri两次
  if (!checkIsAndroid()) {
    const cmd = Object.keys(obj)
      .map(function (key) {
        return `${key}=${encodeURIComponent(encodeURIComponent(obj[key]))}`;
      })
      .join('&');
    executeCmd(cmd);
  } else {
    const cmd = Object.keys(obj)
      .map(function (key) {
        return `${key}=${encodeURIComponent(obj[key])}`;
      })
      .join('&');
    executeCmd(cmd);
  }
}

/**
 * 执行客户端指令
 * @param {String} str
 */
export function executeCmd(str: string) {
  console.log(str);
  if (checkIsAndroid()) {
    if (window.jsInterface) {
      window.jsInterface.execute(str);
    }
  } else {
    const ua = window.navigator.userAgent;
    if (window.webkit) {
      const arr = str.split('&');
      const aCmd = arr[0].split('=');
      const cmd = aCmd[1];
      const extend = str.replace(arr[0] + '&', '');
      window.webkit.messageHandlers[cmd].postMessage(extend);
    } else {
      // 应用内才执行js2oc命令
      window.location.href = 'js2oc://?' + str;
    }
  }
}

/**
 * 在外部浏览器打开页面
 * @param {String} url
 */
export function openUrl(url: string) {
  executeCmd('cmd=open_url&preferred=' + encodeURIComponent(url));
}

/**
 * 显示登录框登录
 * @param {String} userId
 * @param {String} msg
 */
export function preShowLoginBox(userId: string) {
  if (userId.length < 2) {
    const cmd = 'cmd=user_login';
    executeCmd(cmd);
    return true;
  }
  return false;
}

/**
 * 不判断userId长度 登录
 * @param {String} msg
 * @param {String|Number} reload
 */
export function preShowLoginBoxVistor(msg: string, reload = '0') {
  const cmd = `cmd=user_login&msg=${msg}&reload=${reload}`;
  executeCmd(cmd);
  return true;
}

/**
 * 推荐执行客户端指令
 * @param {String} cmd
 * @param {Object} obj
 * @returns {Promise}
 */
export function executeCmdParam(cmd: string, obj: any = {}) {
  obj.cmd = cmd;
  executeCmdByObj(obj);
  return new Promise((resolve: any) => {
    setTimeout(() => {
      resolve();
    }, 100);
  });
}

// 获取客户端权限
export function queryPermissions(permissionsType: string) {
  // 发起客户端获取请求
  executeCmdParam(QUERY_ENABLE, { feat: permissionsType });

  return new Promise(resolve => {
    const timer = setTimeout(() => {
      resolve(0);
    }, 1000);

    // 接收客户端请求后的回调
    window.action.query_permissions = (type: string, state: string) => {
      if (type === permissionsType) {
        timer && clearTimeout(timer);
        const iState = parseInt(state);
        resolve(iState);
      }
    };
  });
}

/**
 * 执行客户端分享
 * @param {Object} objConfig
 * @param {Object} globalConfig {weibo:{title,image}}
 */
export function executeShareCmd(objConfig: any, globalConfig: any = {}) {
  // 禁止用户多次点击响应，函数防抖
  if (objConfig.className.disabled) {
    return false;
  }
  objConfig.className.disabled = true;
  setTimeout(() => (objConfig.className.disabled = false), 2000);

  // 优先当前项配置合并全局配置
  objConfig = Object.assign(globalConfig, objConfig);
  const { shareImg, shareUrl, shareTitle, shareDescr, platform, referrer } = objConfig;

  // 增加平台参数
  const oLink = new URL(shareUrl);
  // 删除冗余平台参数
  if (oLink.searchParams.has('share_platform')) {
    oLink.searchParams.delete('share_platform');
  }
  oLink.searchParams.append('share_platform', platform);

  if (oLink.searchParams.has('um_chnnl')) {
    oLink.searchParams.delete('um_chnnl');
  }
  oLink.searchParams.append('um_chnnl', platform);

  if (oLink.searchParams.has('um_from_appkey')) {
    oLink.searchParams.delete('um_from_appkey');
  }

  const appkeyMap: any = {
    android: {
      langeasy: ANDROID_LANGEASY_APPKEY,
      qlisten: ANDROID_QLISTEN_APPKEY,
      langeasylexis: ANDROID_LEXIS_APPKEY,
    },
    ios: {
      langeasy: IOS_LANGEASY_APPKEY,
      qlisten: IOS_QLISTEN_APPKEY,
      langeasylexis: IOS_LEXIS_APPKEY,
    },
  };

  const appName = getAppName();
  const os = checkIsAndroid() ? 'android' : 'ios';
  const appkey: string = appkeyMap[os][appName];

  oLink.searchParams.append('um_from_appkey', appkey);

  const weburl = oLink.href;

  const oCmd: any = {
    cmd: 'share',
    app: platform,
    weburl: weburl,
  };

  // 来源
  if (referrer) {
    oCmd.referrer = referrer;
  }

  // 微博图片分享需要增加weibo参数
  // globalConfig: {weibo:{title,image}}
  if (platform == 'weibo' && globalConfig.weibo && globalConfig.weibo.image) {
    const { title, image } = globalConfig.weibo;
    oCmd.type = 'image';
    oCmd.title = `${title} ${weburl}`;
    oCmd.imageurl = image;
    oCmd.thumbimage = image;
  } else {
    oCmd.type = 'web';
    oCmd.thumbimage = shareImg;
    oCmd.title = shareTitle;
    oCmd.descr = shareDescr;
  }

  executeCmdByObj(oCmd);
}

/**
 * 透传统计
 * @param {string} event 事件
 * @param {object} properties
 */
export function executeMobclick(event: string, properties: any) {
  const sProperties = encodeURIComponent(JSON.stringify(properties));
  const cmd = `cmd=mobclick&event=${encodeURIComponent(event)}&properties=${sProperties}`;
  executeCmd(cmd);
}
